module.exports = __webpack_public_path__ + "img/EM-FULL_03.468cebf4.png";